import { render, staticRenderFns } from "./Pops.vue?vue&type=template&id=a0bba58c"
import script from "./Pops.vue?vue&type=script&lang=js"
export * from "./Pops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports